import { makeStyles } from "@material-ui/core/styles";

export const platformLogosStyles = makeStyles((theme) => {
  return {
    platformIcon: {
      fill: theme.svgs.platform.color,
    },
  };
});
